import { useQuery } from 'react-query';
import { getPnlAccounts, GetPnlAccountsParams } from '~/api/pnlAccounts';

export const usePnlAccounts = (params?: GetPnlAccountsParams) => {
  return useQuery(['pnlAccounts', params], () => getPnlAccounts(params).then((res) => res.data));
};
